var map = {
	"./asset2.png": "a277",
	"./asset3.png": "b62d",
	"./asset4.png": "9a83",
	"./asset5.png": "3329",
	"./asset6.png": "f77e",
	"./asset7.png": "0297",
	"./group-2.png": "f2d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac8e";